import { useGetChequeGiroClearing } from 'api-hooks/transactions/cheque-giro-clearing';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer } from 'legacy-modules/styles';
import ChequeGiroClearingForm from 'legacy-modules/transactions/cheque-giro-clearing/components/form';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

export type ChequeGiroClearingViewParams = {
  id: string;
};

export default function ChequeGiroClearingView(
  props: NavigationProps<NavigationRoutes.ChequeGiroClearingsView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } =
    useGetChequeGiroClearing({
      id,
    });

  const chequeGiroClearing = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <ChequeGiroClearingForm
            {...props}
            chequeGiroClearing={chequeGiroClearing}
          />
        </>
      }
    />
  );
}
